<template>
    <transition appear name="fade-transition">
        <span class="display__datetime">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled">
                {{ displayValue }}
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayDatetime',
    extends: Display,
    props: {
        showTime: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayValue() {
            if (this._.isNil(this.value) && this.fallback) {
                return this.fallback;
            }

            let format = 'DD/MM/YYYY';

            if (this.showTime || this.getOption('showTime')) {
                format += ' h:mma';
            }

            return this.toDatetime(this.value, this.getOption('format', format));
        }
    }
};
</script>

<style lang="scss" scoped>
.display__datetime {
    min-width: 7rem;
}
</style>
